// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 3694 ? "compute" : chunkId) + ".bundle." + {"573":"e9182fe16a8f12c93a19","2860":"a616715da249a07ed1ef","2914":"f45de6cadc6ab3746501","3396":"262e766abc29886e362f","3694":"53a221191fb829a5f066","9977":"2adb0e3fbbd7756e9471"}[chunkId] + ".js";
};